<template>
  <v-card>
    <v-card-title class="">
      <span class="me-3">({{ prospects.length }}) Prospects</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="prospects"
      item-key="id"
      class="table-rounded"
      :items-per-page="10"
      disable-sort
      :search="search"
    >
      <!-- name -->
      <template #[`item.prospect_name`]="{item}">
        <div class="d-flex flex-column" style="cursor: pointer">
          <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.prospect_name }}</span>
        </div>
      </template>
      <template #[`item.get_date_str`]="{item}">
        {{ item.get_date_str }}
      </template>

      <!-- Actions -->
      <template #[`item.actions`]="{ item }">
        <v-btn
          icon
          small
          color="green"
          @click="openWhatsApp(item)"
          title="Send WhatsApp message"
        >
          <v-icon small>mdi-whatsapp</v-icon>
        </v-btn>

      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical } from '@mdi/js'
import axios from 'axios'

export default {
  data() {
    const statusColor = {
      Withdrawal: 'primary',
      Deposit: 'success',
      Cancelled: 'error',
    }

    return {
      switch1: true,
      headers: [
        { text: 'Name', value: 'prospect_name' },
        { text: 'Profession', value: 'profession' },
        { text: 'Phone Number', value: 'phone_number' },
        { text: 'Email', value: 'email' },
        { text: 'Location', value: 'location' },
        { text: 'Date/Time', value: 'get_date_str' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
      ],
      prospects: [],
      statusColor,
      search: '',

      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
      },
    }
  },

  mounted() {
    this.getProspectsDetails();
    document.title = "TopUp | List of Prospects";
  },

  methods: {
    getProspectsDetails() {
      const list_id = this.$route.params.id;
      axios
        .get('/api/v1/topup/get/prospects_list/' + list_id + '/details/')
        .then(response => {
          this.prospects = response.data;
        })
        .catch(error => {
          if (error.response) {
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText);
            this.$store.commit('setSnackBarColor', "red darken-4");
            this.$store.commit('activateSnackBar', true);
          } else {
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.");
            this.$store.commit('setSnackBarColor', "red darken-4");
            this.$store.commit('activateSnackBar', true);
          }
        });
    },

    openWhatsApp(prospect) {
      const phone = this.formatPhone(prospect.phone_number);
      if (!phone) {
        this.showToast('No valid phone number', 'warning');
        return;
      }
      const message = `Hello ${prospect.prospect_name}, I'm your PettyCash agent. How can I help you?`;
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
    },



    formatPhone(raw) {
      if (!raw) return '';
      let digits = raw.replace(/\D/g, '');
      if (digits.startsWith('0')) digits = digits.substring(1);
      if (digits.length === 9) digits = '237' + digits;  // adapte l'indicatif si nécessaire
      return digits ? `+${digits}` : '';
    },

    showToast(msg, type) {
      this.$store.commit('setSnackBarMessage', msg);
      this.$store.commit('setSnackBarColor', type === 'warning' ? 'orange darken-2' : 'red darken-4');
      this.$store.commit('activateSnackBar', true);
    },
  },
}
</script>
